import {Backdrop, CircularProgress} from "@mui/material";
import { createRoot } from "react-dom/client";

export const Loading = ({open=false}) =>{


    let COMPONENT_LOAD = "comonente-to-loading";
    let ROOT_ALERT_COMPONENT = "content-alert";

    if(open){

        let componetRoot = document.getElementById(ROOT_ALERT_COMPONENT);

        let newAlert = document.createElement("div");


        newAlert.id = COMPONENT_LOAD;
        // ReactDOM.render( <LoadComponent open={open} />, newAlert)
        createRoot(newAlert).render(<LoadComponent open={open} />);

        componetRoot.appendChild(newAlert)
    }else{
        if(document.getElementById(COMPONENT_LOAD)){
            document.getElementById(COMPONENT_LOAD).remove();
        }
    }

}

function LoadComponent({open = false}) {
    return(
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
            open={open}>
            <CircularProgress />
        </Backdrop>
    );
}